<div class="static-desktop-heading">
  {{ 'thematicPortfolios.header' | translate }}
</div>

<div class="desktop-aligment">
  <div class="desktop-image-container desktop-image-container--thematic-portfolios" background></div>

  <div class="desktop-column">
    <div class="static-heading">
      {{ 'thematicPortfolios.subHeader' | translate }}
    </div>

    <div class="static-text" [innerHTML]="'thematicPortfolios.text1' | translate | htmlFormat"></div>

    <div class="phone-image-container">
      <img src="/assets/images/static-pages/foto-tematicka-portfolia.jpg" alt="thematic portfolio banner">
    </div>

    <div class="static-text" [innerHTML]="'thematicPortfolios.text2' | translate | htmlFormat"></div>
  </div>
</div>

<libero-static-page-footer></libero-static-page-footer>
